import { Box, Link } from "@mui/material";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getLookups } from "./lookupAction";
import CustomTable, { IColumn } from "../../common/CustomTable/CustomTable";
import { RootState } from "../../store/store";
import { useNavigate } from "react-router-dom";

const LookupMaster = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { lookupList } = useAppSelector((state: RootState) => state.lookup);
  const { calledReducerType, isLoading } = useAppSelector(
    (store: RootState) => store.common
  );

  const handleNameClick = (name: string) => {
    navigate(`${name}`);
  };

  useEffect(() => {
    dispatch(getLookups());
  }, [dispatch]);

  const getListSection = () => {
    const columns: IColumn[] = [
      {
        label: "Name",
        accessorKey: "name",
        Cell: (lookup: any) => (
          <Link
            onClick={() => handleNameClick(lookup.name)}
            sx={{ cursor: "pointer" }}
          >
            {lookup.label}
          </Link>
        ),
      },
      {
        label: "Description",
        accessorKey: "description",
      },
      {
        label: "Number of Items",
        accessorKey: "numberOfItems",
      },
    ];

    return (
      <CustomTable
        columns={columns}
        data={[...lookupList].reverse()}
        stickyHeader={true}
        pagination={true}
        displaySkeleton={isLoading && calledReducerType === "lookup/getLookups"}
      />
    );
  };

  return (
    <Box 
      sx={{ paddingY: 3 }}
      id="lookup_master_section"
      data-test-id="lookup_master_section"
      aria-label="Lookup master section"
    >
      {getListSection()}
    </Box>
  );
};

export default LookupMaster;
